// extracted by mini-css-extract-plugin
module.exports = {"BannerContainer":"BannerContainer_BannerContainer__3aDlb","BannerDesk":"BannerContainer_BannerDesk__3Ji7g","BannerMob":"BannerContainer_BannerMob__2SYE9"};